/**
 * Created by richard on 7/17/14.
 */
var accountModel = angular.module('accountModel', ['schoolModel']);
accountModel.factory('AccountModelFactory', function(SchoolModelFactory){
    var AccountModel = function(){
        this.endpoint = '/accounts';
        this.primaryKey = 'recordID';

    }
    AccountModel.prototype = new SchoolModelFactory();
    AccountModel.prototype.parent = SchoolModelFactory.prototype;
    AccountModel.prototype.new = function()
    {
        var schoolID = this.arg;
        return this.data.accounts.push (
            {
                schoolID: schoolID, Account: '', Budget: '', Active: '1', deleted: '0', showDeleted: '0'
            }
        ) - 1;

    }
    return AccountModel;
});


accountModel.service('AccountModelService', function(AccountModelFactory){
    var accountModel = new AccountModelFactory();
    return accountModel;
});


